import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IrisDateAgoPipeModule } from './pipes/date-ago/date-ago.module';
import { NgLatinizePipeModule } from './latinize/latinize.pipe';
import { FilterByPipe } from '@iris/common/modules/pipes-common/pipes/array-utils/filterBy.pipe';
import { ExcludePipe } from '@iris/common/modules/pipes-common/pipes/array-utils/exclude.pipe';
import { IrisTranslatePipe } from './pipes/translate/translate.pipe';
import { IrisFilterFieldPipe } from './pipes/filter-field/filter-field.pipe';
import { IrisFileSizePipe } from './pipes/filesize/file-size.pipe';
import { IrisHighlightTextPipe } from './pipes/highlight-text/highlight-text.pipe';
import { IrisHighlightUrlPipe } from './pipes/highlight-url/highlight-url.pipe';
import { ColorIsDarkPipe } from './pipes/color-is-dark/color-is-dark.pipe';
import { IrisUnitsPipe } from './pipes/units/units.pipe';
import { IrisDateAgoPipe } from './pipes/date-ago/date-ago.pipe';
import { IrisTranslationPipe } from '@iris/common/modules/pipes-common/pipes/translate/translation.pipe';
import { SafeHtmlPipe } from './pipes';

@NgModule({
  imports: [
    CommonModule,
    SafeHtmlPipe,
    IrisDateAgoPipeModule,
    NgLatinizePipeModule,
    IrisTranslatePipe,
    IrisTranslationPipe,
    ExcludePipe,
    FilterByPipe,
    IrisFileSizePipe,
    IrisHighlightTextPipe,
  ],
  declarations: [
    IrisFilterFieldPipe,
    IrisHighlightUrlPipe,
    ColorIsDarkPipe,
    IrisUnitsPipe,
  ],
  exports: [
    IrisFilterFieldPipe,
    IrisFileSizePipe,
    IrisTranslatePipe,
    IrisTranslationPipe,
    IrisHighlightUrlPipe,
    ColorIsDarkPipe,
    IrisUnitsPipe,
    IrisDateAgoPipe,
    IrisHighlightTextPipe,
  ],
  providers: [
    IrisFilterFieldPipe,
    IrisFileSizePipe,
    IrisTranslatePipe,
    IrisTranslationPipe,
    IrisHighlightUrlPipe,
    ColorIsDarkPipe,
    IrisUnitsPipe,
  ],
})
export class IrisCommonPipesModule {
}
